import { observable, makeAutoObservable, action } from "mobx";
import { GetGoldPrice as GetGoldPriceService } from "../services/MasterData";
import {GetAppInfo as GetAppInfoService } from "../services/App";

export default class UserStore {
  @observable isOpenSidebar: boolean = true;
  @observable sidebarScrollTop: number = 0;
  @observable goldSellNow: number = 0;
  @observable goldPurchaseNow: number = 0;
  @observable goldDateTime: string = "";
  @observable goldFetchTimeEvery: number = 300000;
  @observable goldLatestCheck: string = "";
  @observable apiAppVersion: string = "unknown";

  constructor() {
    makeAutoObservable(this);
  }

  @action
  handleSidebar = (isOpen: boolean) => {
    this.isOpenSidebar = isOpen;
  };

  @action
  setSidebarScrollTop = (scrollTop: number) => {
    this.sidebarScrollTop = scrollTop;
  };

  setStore(data: any) {
    this.goldSellNow = data?.priceSale;
    this.goldPurchaseNow = data?.pricePurchase;
    this.goldDateTime = data?.date;
    this.goldFetchTimeEvery = data?.minutes * 60 * 1000;
    this.goldLatestCheck = data?.latestCheck;
  }

  @action
  getGoldPrice = async () => {
    const response = await GetGoldPriceService();
    if (!response.success) return false;
    this.setStore(response.data);
  };

  @action
  getAppVersion = async () => {
    const response = await GetAppInfoService();
    if (!response.success) return false;
    this.apiAppVersion = response.data?.appVersion || "unknown";
  }
}
